<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col md="12" lg="12" sm="6" class="px-0 pb-0">
          <v-btn
            fab
            x-small
            class="mx-2 mb-2"
            color="white"
            @click="$router.back()"
          >
            <v-icon light>mdi-arrow-left</v-icon>
          </v-btn>
          <!-- Main Container -->
          <v-card class="mt-4" rounded="xl" color="blue lighten-5" width="auto">
            <!-- Dashboard Container -->
            <v-container fluid>
              <v-row class="ma-0 py-4" align="center" justify="center">
                <!-- Category Section -->
                <v-col
                  cols="6"
                  sm="3"
                  md="3"
                  class="pa-3 d-flex align-center justify-center"
                >
                  <span class="text-h4">{{
                    category || "All Categories"
                  }}</span>
                </v-col>

                <!-- Presents Section -->
                <v-col
                  cols="6"
                  sm="3"
                  md="3"
                  class="pa-3 d-flex align-center justify-center"
                >
                  <v-icon
                    size="48"
                    color="black"
                    @click="handleSectionClick('presents')"
                    >mdi-account-check</v-icon
                  >
                  <span class="text-body-1 ml-3">Presents:</span>
                  <span
                    class="black--text text-body-1 ml-2 pointer"
                    @click="handleSectionClick('presents')"
                    >{{ siteData.present_count || 0 }}</span
                  >
                </v-col>

                <!-- Absents Section -->
                <v-col
                  cols="6"
                  sm="3"
                  md="3"
                  class="pa-3 d-flex align-center justify-center"
                >
                  <v-icon
                    size="48"
                    color="black"
                    @click="handleSectionClick('absents')"
                    >mdi-account-minus</v-icon
                  >
                  <span class="text-body-1 ml-3">Absents:</span>
                  <span
                    class="black--text text-body-1 ml-2 pointer"
                    @click="handleSectionClick('absents')"
                    >{{ siteData.absent_count || 0 }}</span
                  >
                </v-col>

                <!-- Month-Year Section -->
                <v-col
                  cols="6"
                  sm="3"
                  md="3"
                  class="pa-3 d-flex align-center justify-center"
                >
                  <span class="text-body-1">Select Month:</span>
                  <v-dialog
                    :close-on-content-click="false"
                    ref="dialog"
                    hide-details
                    v-model="modal"
                    :return-value.sync="form.date"
                    persistent
                    width="100%"
                    max-width="320px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.month_year_filter_formatted"
                        label="Select Month - Year"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                        rounded
                        class="text-body-2 ml-3"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.date"
                      type="month"
                      scrollable
                      @change="customMonthFormat"
                      @input="modal = false"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>

              <!-- Select Group and Select Division in one row -->
              <!-- <v-row class="ma-0 py-4" align="center" justify="center"> -->
              <!-- Group Section -->
              <!-- <v-col cols="12" sm="4" md="4" class="pa-3">
                  <div class="d-flex align-center mb-3">
                    <h4>Select Group</h4>
                  </div>
                  <v-select
                    solo
                    hide-details
                    rounded
                    v-model="form.group_id"
                    :items="groups"
                    item-text="text"
                    item-value="value"
                    label="Group"
                    class="text-body-2"
                    @change="getGroupDivisions()"
                  ></v-select>
                </v-col> -->

              <!-- Division Section -->
              <!-- <v-col cols="12" sm="4" md="4" class="pa-3">
                  <div class="d-flex align-center mb-3">
                    <h4>Select Division</h4>
                  </div>
                  <v-select
                    solo
                    hide-details
                    rounded
                    v-model="form.group_division_id"
                    :items="group_divisions"
                    item-text="text"
                    item-value="value"
                    label="Division"
                    class="text-body-2"
                  ></v-select>
                </v-col> -->

              <!-- Month-Year Section -->
              <!-- <v-col cols="12" sm="4" md="4" class="pa-3 mt-7">
                  
                </v-col> -->
              <!-- </v-row> -->

              <!-- Loading State -->
              <template v-if="isEmployeeLoading">
                <v-row class="ma-0 my-4">
                  <v-col class="pa-0">
                    <v-card rounded="xl" elevation="10">
                      <v-row class="ma-0">
                        <v-col class="pa-4">
                          <span
                            >Kindly wait, we are fetching employee data...</span
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
              <!-- No Data State -->
              <template v-else-if="employees.length === 0">
                <v-row class="ma-0 my-4">
                  <v-col class="pa-0">
                    <v-card rounded="xl" elevation="10">
                      <v-row class="ma-0">
                        <v-col class="pa-4">
                          <span
                            >No employee attendance data available for the
                            selected filters.</span
                          >
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
              <!-- Employee Table -->
              <template v-else>
                <v-row class="ma-0 my-4">
                  <v-col class="pa-0">
                    <v-card rounded="xl" elevation="10">
                      <v-row class="ma-0">
                        <v-col class="pa-4">
                          <v-simple-table fixed-header ref="attendanceTable">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th style="min-width: 50px">Sr. No</th>
                                  <th style="min-width: 96px">Emp Code</th>
                                  <th
                                    style="min-width: 200px"
                                    class="sticky-header"
                                  >
                                    Name
                                  </th>
                                  <!-- Current day column -->
                                  <th
                                    v-if="currentDay <= totalDaysInMonth"
                                    :key="`day${currentDay}`"
                                    class="current-date"
                                    style="min-width: 50px"
                                    ref="currentDayColumn"
                                  >
                                    {{ currentDay }}
                                  </th>
                                  <!-- Other days in series -->
                                  <th
                                    v-for="day in otherDays"
                                    :key="`day${day}`"
                                    style="min-width: 50px"
                                  >
                                    {{ day }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(employee, index) in employees"
                                  :key="`employee${index}`"
                                >
                                  <td style="min-width: 50px">
                                    {{ index + 1 }}
                                  </td>
                                  <td
                                    style="min-width: 96px"
                                    @click="
                                      calendarDialog = true;
                                      getMonthlyAttendanceData(employee.id);
                                      displayEmployeeName = employee.full_name;
                                      displayEmployeeImage =
                                        employee.image_path;
                                    "
                                  >
                                    <v-avatar v-if="employee.image_path">
                                      <img
                                        :src="mediaUrl + employee.image_path"
                                        alt="Profile"
                                      />
                                    </v-avatar>
                                    {{ employee.employee_id }}
                                  </td>
                                  <td
                                    style="min-width: 200px"
                                    class="sticky-column"
                                  >
                                    {{ employee.full_name }}
                                  </td>
                                  <!-- Current day cell -->
                                  <td
                                    v-if="currentDay <= totalDaysInMonth"
                                    :key="`day${currentDay}`"
                                    style="min-width: 50px"
                                    class="current-date-cell"
                                  >
                                    <v-icon
                                      v-if="
                                        employee[`day_${currentDay}`]
                                          ?.status === 'A'
                                      "
                                      color="red"
                                      >mdi-circle</v-icon
                                    >
                                    <v-icon
                                      v-if="
                                        employee[`day_${currentDay}`]
                                          ?.status === 'P'
                                      "
                                      color="green"
                                      @click="
                                        attendanceDetails(
                                          employee[`day_${currentDay}`]
                                        )
                                      "
                                      >mdi-circle</v-icon
                                    >
                                    <v-icon
                                      v-if="
                                        employee[`day_${currentDay}`]
                                          ?.status === 'R'
                                      "
                                      color="blue"
                                      >mdi-circle</v-icon
                                    >
                                  </td>
                                  <!-- Other days cells -->
                                  <td
                                    v-for="day in otherDays"
                                    :key="`day${day}`"
                                    style="min-width: 50px"
                                  >
                                    <v-icon
                                      v-if="
                                        employee[`day_${day}`]?.status === 'A'
                                      "
                                      color="red"
                                      >mdi-circle</v-icon
                                    >
                                    <v-icon
                                      v-if="
                                        employee[`day_${day}`]?.status === 'P'
                                      "
                                      color="green"
                                      @click="
                                        attendanceDetails(
                                          employee[`day_${day}`]
                                        )
                                      "
                                      >mdi-circle</v-icon
                                    >
                                    <v-icon
                                      v-if="
                                        employee[`day_${day}`]?.status === 'R'
                                      "
                                      color="blue"
                                      >mdi-circle</v-icon
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <!-- Attendance Details Dialog -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card rounded="xl">
          <v-row class="ma-0 pa-3">
            <v-col class="pa-0">In Time</v-col>
            <v-col class="pa-0">
              : {{ employeeAttendanceDetails.in_time || "" }}
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-3">
            <v-col class="pa-0">Out Time</v-col>
            <v-col class="pa-0">
              : {{ employeeAttendanceDetails.out_time || "" }}
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-3">
            <v-col class="pa-0">Current Location</v-col>
            <v-col class="pa-0">
              : {{ employeeAttendanceDetails.address || "" }}
            </v-col>
          </v-row>
          <v-card-actions justify="center">
            <v-row justify="center" class="my-4">
              <v-btn
                color="blue darken-1"
                rounded
                @click="dialog = false"
                class="mx-2"
                dark
              >
                OK
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Daily Tasks Dialog -->
      <v-row justify="center">
        <v-dialog
          v-model="userDailyTaskDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="userDailyTaskDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>User daily summaries</v-toolbar-title>
            </v-toolbar>
            <v-list three-line subheader>
              <v-subheader
                >{{ displayEmployeeName }}'s daily summaries</v-subheader
              >
            </v-list>
            <v-row class="pa-0">
              <v-col class="ma-3">
                <v-row
                  class="ma-0"
                  v-for="(user_daily_task, index) in user_daily_tasks"
                  :key="index"
                >
                  <v-col class="pa-0" style="max-width: 70px">
                    <h5 class="mt-2">
                      {{ user_daily_task.from_time || "" }} <br />
                      To<br />
                      {{ user_daily_task.to_time || "" }}
                    </h5>
                  </v-col>
                  <v-col class="pa-0 pl-2">
                    <v-card rounded="xl">
                      <v-row class="ma-2">
                        <v-col class="pa-2">
                          <v-row>
                            <v-col style="min-width: 160px; min-height: 50px">
                              <span
                                class="blue--text subtitle-2 text--darken-2 font-weight-bold"
                              >
                                {{ user_daily_task.daily_task?.code || "" }}
                              </span>
                            </v-col>
                            <v-col
                              class="text-right pa-0 ma-0 mt-3 mr-4"
                              style="max-width: fit-content"
                            >
                              <span class="subtitle-2 text--darken-2">
                                {{
                                  user_daily_task.is_done == 1
                                    ? "Completed"
                                    : "Pending"
                                }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-row class="ma-0">
                            <v-col style="min-width: 90px" class="pa-0">
                              <span class="grey--text caption font-weight-bold">
                                Remarks: {{ user_daily_task.description || "" }}
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <template v-if="user_daily_tasks.length === 0">
              <v-row justify="center">
                <v-col align="center" style="min-height: 100px">
                  <span>No tasks for the selected date.</span>
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- Monthly Attendance Dialog -->
      <v-row justify="center">
        <v-dialog
          v-model="calendarDialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="calendarDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Monthly Attendance</v-toolbar-title>
            </v-toolbar>
            <v-list three-line subheader>
              <v-row>
                <v-col
                  ><v-subheader
                    >{{ displayEmployeeName }}'s Monthly Attendance</v-subheader
                  ></v-col
                >
                <v-col>
                  <v-subheader
                    ><v-avatar v-if="displayEmployeeImage != ''">
                      <img
                        :src="mediaUrl + displayEmployeeImage"
                        alt="Profile"
                      /> </v-avatar></v-subheader
                ></v-col>
              </v-row>

              <v-row class="pa-0">
                <v-col class="ma-3">
                  <v-sheet height="600">
                    <v-calendar
                      ref="calendar"
                      v-model="selectedDate"
                      :events="events"
                      :event-overlap-mode="mode"
                      :event-overlap-threshold="30"
                      @click:event="showEvent"
                      @click:date="getUserDailyTasks"
                      type="month"
                    ></v-calendar>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-list>
            <v-list>
              <v-list-item>
                <v-row align="center" class="w-100">
                  <v-col cols="6">
                    <v-list-item-title>Total Absent</v-list-item-title>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{ userAttendances.absent || 0 }}
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row align="center" class="w-100">
                  <v-col cols="6">
                    <v-list-item-title>Total Present</v-list-item-title>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{ userAttendances.present || 0 }}
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row align="center" class="w-100">
                  <v-col cols="6">
                    <v-list-item-title>Total Half Day</v-list-item-title>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{ userAttendances.less_than_5_hrs || 0 }}
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row align="center" class="w-100">
                  <v-col cols="6">
                    <v-list-item-title>Total Overtime</v-list-item-title>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{ userAttendances.greater_than_5_hrs || 0 }}
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row align="center" class="w-100">
                  <v-col cols="6">
                    <v-list-item-title>Total Penalty</v-list-item-title>
                  </v-col>
                  <v-col cols="6" class="text-right">0</v-col>
                </v-row>
              </v-list-item>
              <v-list-item v-if="userAttendances.is_smily == 1">
                <v-row align="center" class="w-100">
                  <v-col cols="6">
                    <v-list-item-title>
                      <v-icon size="60" color="yellow"
                        >mdi-emoticon-outline</v-icon
                      >
                    </v-list-item-title>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card>
        </v-dialog>

        <!-- Event Status Dialog -->
        <v-dialog v-model="eventDialog" max-width="400px">
          <v-card>
            <v-card-title class="headline">Attendance Details</v-card-title>
            <v-card-text>
              <p><strong>Date:</strong> {{ selectedEvent.date || "" }}</p>
              <p><strong>Status:</strong> {{ selectedEvent.status || "" }}</p>
              <p><strong>Duration:</strong> {{ selectedEvent.detail || "" }}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="eventDialog = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-container class="footer-text mt-8">
        <v-row justify="center">
          <v-col align="center">
            <h3 class="white--text">We Alliance Sparkle</h3>
            <h4 class="white--text">v 1.0.0</h4>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      currentDay: new Date().getDate(),
      form: {
        date: new Date().toISOString().substr(0, 7),
        month_year_filter_formatted: moment().format("MMM-YYYY"),
        group_id: null,
        group_division_id: null,
        session_type_id: "All",
      },
      siteData: {}, // Holds total_employees, present_count, etc.
      employees: [],
      employeeAttendanceDetails: {},
      dialog: false,
      userDailyTaskDialog: false,
      calendarDialog: false,
      displayEmployeeName: "",
      displayEmployeeImage: "",
      employee_id: "",
      user_daily_tasks: [],
      userAttendances: {},
      selectedDate: new Date().toISOString().substr(0, 10),
      events: [],
      eventDialog: false,
      selectedEvent: {},
      mode: "stack",
      groups: [],
      group_divisions: [],
      sites: [{ text: "ALL", value: "All" }],
      sessionsTypes: [
        { text: "ALL", value: "All" },
        { text: "ABSENT", value: "Absent" },
        { text: "PRESENT", value: 50 },
        { text: "HALF DAY", value: 51 }, // Adjust value based on backend
        { text: "LEAVE", value: 52 }, // Adjust value based on backend
      ],
      isEmployeeLoading: false,
      totalDaysInMonth: moment().daysInMonth(),
      count: 0,
      modal: false,
      // mediaUrl: process.env.VUE_APP_MEDIA_URL || "your-media-url-base",
      category: "",
    };
  },
  computed: {
    otherDays() {
      return Array.from(
        { length: this.totalDaysInMonth },
        (_, i) => i + 1
      ).filter((day) => day !== this.currentDay);
    },
  },
  async mounted() {
    await this.getMasters();
    await this.customMonthFormat();
    this.$nextTick(() => {
      this.scrollToCurrentDay();
    });
  },
  watch: {
    employees: {
      handler() {
        if (
          this.employees.length > 0 &&
          this.currentDay <= this.totalDaysInMonth
        ) {
          this.$nextTick(() => {
            this.scrollToCurrentDay();
          });
        }
      },
      deep: true,
    },
    // "form.group_id": function () {
    //   // this.getGroupDivisions();
    //   this.getEmployeesPunchData();
    // },
    // "form.group_division_id": function () {
    //   this.getEmployeesPunchData();
    // },
    // "form.session_type_id": function () {
    //   this.getEmployeesPunchData();
    // },
  },
  methods: {
    scrollToCurrentDay() {
      const table = this.$refs.attendanceTable?.$el;
      if (table && this.currentDay <= this.totalDaysInMonth) {
        const tableContainer = table.querySelector(".v-data-table__wrapper");
        const currentDayColumn = this.$refs.currentDayColumn?.$el;
        if (tableContainer && currentDayColumn) {
          const stickyColumnsWidth = 50 + 96 + 200; // Sr. No (50px) + Emp Code (96px) + Name (200px)
          const scrollLeft = currentDayColumn.offsetLeft - stickyColumnsWidth;
          tableContainer.scrollLeft = scrollLeft >= 0 ? scrollLeft : 0;
        }
      }
    },
    async getMasters() {
      try {
        const masters = await axios.get("/monthly_salaries/masters");
        masters.data.sites.forEach((site) => {
          this.sites.push({
            id: site.id,
            text: site.name,
            value: site.id,
          });
        });
        masters.data.session_types.forEach((session_type) => {
          this.sessionsTypes.push({
            id: session_type.id,
            text: session_type.description,
            value: session_type.id,
          });
        });
        // await this.getgroups();
      } catch (error) {
        console.error("Error fetching masters:", error);
      }
    },
    async getgroups() {
      this.groups = [];
      let site_id = this.user?.sites?.[0]?.id || this.form.site_id || "";
      try {
        const groups = await axios.get(`/groups?site_id=${site_id}`);
        groups.data.data.forEach((group) => {
          this.groups.push({
            id: group.id,
            text: group.name,
            value: group.id,
          });
        });
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    },
    async getGroupDivisions() {
      this.group_divisions = [];
      if (!this.form.group_id) return;
      try {
        const group_divisions = await axios.get(
          `/groups/${this.form.group_id}/group_divisions`
        );
        group_divisions.data.data.forEach((group_division) => {
          this.group_divisions.push({
            id: group_division.id,
            text: group_division.division_name,
            value: group_division.id,
          });
        });
      } catch (error) {
        console.error("Error fetching group divisions:", error);
      }
    },
    async getEmployeesPunchData() {
      try {
        this.isEmployeeLoading = true;
        const [year, month] = this.form.date.split("-");
        const category = this.$route.query.category ?? "";
        this.category = category;
        const role =
          category === "Site Supervisor" ||
          category === "Operation Manager" ||
          category === "Rounder Supervisor" ||
          category === "Area Supervisor"
            ? "Supervisor"
            : this.$route.query.role ?? "";
        const session_type = this.form.session_type_id ?? "All";
        const group_id = this.form.group_id ?? "";
        const group_division_id = this.form.group_division_id ?? "";
        const site_id = this.user?.sites?.[0]?.id || this.form.site_id || "";

        const query = `monthId=${month}&year=${year}&category=${category}&role=${role}&site_id=${site_id}&group_id=${group_id}&group_division_id=${group_division_id}&session_type_id=${session_type}`;
        const response = await axios.get(`/user_punches/masterFilter?${query}`);

        const siteName = Object.keys(response.data.data)[0] || "site";
        this.siteData = response.data.data[siteName] || {
          employees: [],
          total_employees: 0,
          present_count: 0,
          absent_count: 0,
          reliever_count: 0,
        };
        this.employees = this.siteData.employees.filter(
          (employee) => employee.employee_id != null
        );
        this.count = response.data.count || 0;
        this.siteData.present_count =
          response.data.overall_counts.present_count || 0;
        this.siteData.absent_count =
          response.data.overall_counts.absent_count || 0;
        this.siteData.reliever_count =
          response.data.overall_counts.reliever_count || 0;
      } catch (error) {
        console.error("Error fetching employees:", error);
        this.employees = [];
        this.siteData = {
          total_employees: 0,
          present_count: 0,
          absent_count: 0,
          reliever_count: 0,
        };
        this.count = 0;
      } finally {
        this.isEmployeeLoading = false;
      }
    },
    async getMonthlyAttendanceData(user_id) {
      console.log("Employee" + this.user.full_name);

      this.isLoading = true;
      // let MonthYear = this.form.month_year_filter_formatted.split("-");
      // let getmonth = moment().month(MonthYear[0]).format("M");
      const [year, month] = this.form.date.split("-");
      this.selectedDate = new Date(year, month, 0);
      let events = [];
      let userId = user_id;
      this.employee_id = userId;
      let userAttendances = await axios.get(
        `/attendanceMonthlyCalendar?userId=${userId}&year=${year}&month=${month}`
      );
      this.userAttendances = userAttendances.data.data;

      this.userAttendances.attendances.forEach((attendance) => {
        let name = "";
        name = attendance.status;

        events.push({
          name: name,
          start: attendance.date,
          color: attendance.color,
          detail: attendance.detail,
          // end: "2024-08-05",
        });
        this.events = events;
      });
      console.log(this.events);
      this.isLoading = false;
    },
    async getUserDailyTasks({ date }) {
      this.userDailyTaskDialog = true;
      try {
        const query = `userId=${this.employee_id}&date=${date}`;
        const response = await axios.get(
          `/users/${this.employee_id}/user_daily_summaries?${query}`
        );
        this.user_daily_tasks = response.data.data || [];
      } catch (error) {
        console.error("Error fetching daily tasks:", error);
        this.user_daily_tasks = [];
      }
    },
    attendanceDetails(dayData) {
      this.employeeAttendanceDetails = {
        in_time: dayData?.in_time || "",
        out_time: dayData?.out_time || "",
        address: dayData?.punch?.address || "",
      };
      this.dialog = true;
    },
    customMonthFormat() {
      const [year, month] = this.form.date.split("-");
      this.form.month_year_filter_formatted = `${moment(month, "M").format(
        "MMM"
      )}-${year}`;
      this.totalDaysInMonth = moment(
        `${year}-${month}`,
        "YYYY-MM"
      ).daysInMonth();
      this.getEmployeesPunchData();
      if (this.currentDay <= this.totalDaysInMonth) {
        this.$nextTick(() => {
          this.scrollToCurrentDay();
        });
      }
    },
    handleSectionClick(session) {
      if (session === "employees") {
        this.form.session_type_id = "All";
      } else if (session === "presents") {
        this.form.session_type_id = 50; // PRESENT
      } else if (session === "absents") {
        this.form.session_type_id = "Absent";
      } else if (session === "relievers") {
        this.form.session_type_id = "All"; // Adjust if relievers have a specific session_type_id
      }
      this.getEmployeesPunchData();
    },
    showEvent({ event }) {
      this.selectedEvent = {
        date: event.day?.date || "",
        status: event.name || "",
        detail: event.detail || "No details available",
      };
      this.eventDialog = true;
    },
    isEnableIn() {
      // Placeholder: Implement based on your needs
      return false;
    },
    isEnableOut() {
      // Placeholder: Implement based on your needs
      return false;
    },
  },
};
</script>

<style scoped>
.sticky-column {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 1;
}
.sticky-header {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 3;
}
.text-right {
  text-align: right;
  padding-right: 5px;
}
.current-date {
  background-color: #e0f7fa;
}
.current-date-cell {
  background-color: #e8f5e9;
}
.v-data-table__wrapper {
  overflow-x: auto;
}
.v-calendar .v-calendar__event-more {
  display: none !important;
}
</style>
